import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  SimpleForm,
  Edit,
  TextInput,
  Create,
  TabbedForm,
  FormTab,
  Filter,
  EditButton,
} from "react-admin";
import MyUrlField from "./MyUrlField";

//import AvatarField from "./AvatarField";

const CandidateFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Name" source="name" resettable alwaysOn />
  </Filter>
);

export const CandidateList = (props) => (
  <List
    title="Candidates"
    {...props}
    filters={<CandidateFilter />}
    exporter={false}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Name" source="name" />
      <TextField label="Job Reference" source="jobheadline" />
      <MyUrlField source="link" filename="filename" />
      <DateField
        label="Last Update"
        source="lastupdate"
        locales="lt"
      />
      <EditButton />
    </Datagrid>
  </List>
);

const CandidateName = ({ record }) => {
  return <span>Candidate {record ? `"${record.name}"` : ""}</span>;
};

export const CandidateEdit = (props) => (
  <Edit title={<CandidateName />} {...props}>
    <TabbedForm>
      <FormTab label="Candidate information">
        <TextInput source="name" />
        <TextInput label="email" source="email" />
        <TextInput label="Job Reference" source="jobheadline" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const CandidateCreate = (props) => (
  <Create title="Create Candidate" {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput label="Email" source="email" />
      <TextInput label="Job Reference" source="jobheadline" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/candidates.js